module.exports = __webpack_public_path__ + "static/img/直播.bfb65544.png";